import { Serializable } from '@core/models';

export class PrintMenuCurrency extends Serializable {
  constructor(guid, name, currencyCode, symbol, symbolPosition, isActive) {
    super();
    this.guid = guid;
    this.name = name;
    this.currencyCode = currencyCode;
    this.symbol = symbol;
    this.symbolPosition = symbolPosition;
    this.isActive = isActive;
  }

  serialize() {
    return {};
  }

  static toInstance(props = {}) {
    return new PrintMenuCurrency(props.guid, props.name, props.currency_code, props.symbol, props.symbol_position, props.is_active);
  }
}
